import React, { useState } from 'react';
import {
  TextField, Button, Paper, Typography, Grid
} from '@material-ui/core';
import api from './api';
import { toast } from 'react-toastify';

const ContactManager = ({siteData, refetch}) => {
  const [contact, setContact] = useState( siteData?.contact?.[0]?{
    site: siteData?.ID, // Static site ID

        id: siteData?.contact?.[0]?.id,

    address: siteData?.contact?.[0]?.address,
    phone: siteData?.contact?.[0]?.phone,
    email: siteData?.contact?.[0]?.email,
    facebook: siteData?.contact?.[0]?.facebook,
    whatsapp: siteData?.contact?.[0]?.whatsapp,
    instagram: siteData?.contact?.[0]?.instagram,
    linkedin: siteData?.contact?.[0]?.linkedin,
    map: siteData?.contact?.[0]?.map,
        footerText: siteData?.contact?.[0]?.footerText,

  }:{
    site: siteData?.ID, // Static site ID
    address: "",
    phone: "",
    email: "",
    facebook:"",
    whatsapp: "",
    instagram: "",
    linkedin: "",
    map: "",
    footerText:''
  });
  const [processing, setProcessing] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;


    if(name==='map'&&value.includes('iframe')){
     let match= value.match(/src="([^"]+)"/);
     if(match){
    setContact({ ...contact, [name]: match[1] });

     console.log(match,value)


     }
     else{
          setContact({ ...contact, [name]: value });

     }
    }

    else{
    setContact({ ...contact, [name]: value });

    }
  };

  const handleSubmit = async () => {
    const formData = new FormData();


    const { phone, email, map } = contact;

 
  const isIframe = map?.trim().includes('https://www.google.com/maps/');
  if (!isIframe) {
    toast.error('Please enter a valid iframe embed link for the map');
    return;
  }

  const phoneRegex = /^[0-9+\-\s()]{7,20}$/;
  if (phone && !phoneRegex.test(phone)) {
    toast.error('Please enter a valid phone number');
    return;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (email && !emailRegex.test(email)) {
    toast.error('Please enter a valid email address');
    return;
  }
    Object.entries(contact).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append('site',siteData?.ID)
setProcessing(true);

    try {
      
      if (contact.id) {
              formData.append('id', contact.id);

              
              await api.put('contact-v2', formData);
              toast.success(`Contact  updated`);
            } else {
              await api.post('contact-v2', formData);
      toast.success(`Contact created`);
            }
    
    refetch()
    } catch (err) {
      console.error(err);
            setProcessing(false);

      toast.error('Failed to save contact');
    }
  };

  return (
    <Paper style={{ padding: 20 }}>
      <Typography variant="h6">Contact Information</Typography>
      <Grid container spacing={2}>
        {[
          'address',
          'phone',
          'email',
          'facebook',
          'whatsapp',
          'instagram',
          'linkedin',
          'map',
          'footerText'
        ].map((field) => (
          <Grid item xs={12} sm={6} key={field}>
            <TextField
              fullWidth
              label={field.charAt(0).toUpperCase() + field.slice(1)}
              name={field}
              value={contact[field]}
              onChange={handleChange}
              multiline
              rows={2}
            />
          </Grid>
        ))}

        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            {processing?"Saving":"Save Contact Info"}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ContactManager;
